<template>
  <Toast position="top-right" group="validation">
    <template #container="{ message, closeCallback }">
      <section class="flex flex-col gap-4 w-full p-4 rounded-xl bg-white text-gray-800 shadow-md border-l-4 border-red-500">
        <div class="flex justify-between items-start">
          <div class="flex flex-col gap-1">
            <span class="font-bold text-base text-red-600">
              {{ message.summary || 'Error' }}
            </span>
            <ul v-if="message.errors && message.errors.length" class="list-disc list-inside space-y-1 text-sm">
              <li v-for="(err, i) in message.errors" :key="i">{{ err }}</li>
            </ul>
          </div>
          <button @click="closeCallback" class="text-gray-400 hover:text-gray-600 text-xl font-bold">&times;</button>
        </div>
      </section>
    </template>
  </Toast>
</template>
